import { useRef } from 'react';

/**
 * Custom hook to stabilize array based on content, not reference.
 * This prevents unnecessary re-renders when the array content is the same
 * but the array reference has changed.
 */
export function useStableArray<T>(array: T[], keyFn: (item: T) => string): T[] {
    const prevKey = useRef<string>('');
    const prevArray = useRef<T[]>([]);

    const currentKey = array.map(keyFn).sort().join(',');

    if (currentKey !== prevKey.current) {
        prevKey.current = currentKey;
        prevArray.current = array;
    }

    return prevArray.current;
}
